export default {
  'menu.afr': '日本 AFR',
  'menu.afr.new': '新建 AFR',
  'menu.afr.list': 'AFR 列表',
  'menu.afr.afr_new': '新建 AFR',
  'menu.afr.afr_list': '查询',
  'afr.title.new': '新建日本 AFR',
  'afr.tab.info': '申报信息',
  'afr.tab.documents': '文档',
  'afr.section.filing': '申报与航线信息',
  'afr.section.containers': '主单集装箱',
  'afr.section.houses': '分单',
  'afr.section.parties': '申报关系方',
  'afr.field.status': '状态',
  'afr.field.masterBillNo': '主提单号',
  'afr.field.houseNo': '分提单号',
  'afr.field.filingType': '申报类型',
  'afr.field.filerCode': '申报人代码',
  'afr.field.opType': '操作类型',
  'afr.field.originAgent': '起运代理代码',
  'afr.field.destinationAgent': '目的代理代码',
  'afr.field.carrier': '承运人',
  'afr.field.carrierName': '承运人名称',
  'afr.field.carrierCode': '承运人代码',
  'afr.field.consignmentType': '托运类型',
  'afr.field.departureVessel': '离港船名',
  'afr.field.arrivalVessel': '到港船名',
  'afr.field.voyage': '航次',
  'afr.field.imo': 'IMO 编号',
  'afr.field.flag': '船旗',
  'afr.field.callSign': '呼号',
  'afr.field.loadingPort': '装货港',
  'afr.field.transhipPort': '中转港',
  'afr.field.dischargePort': '卸货港',
  'afr.field.destinationPort': '目的港',
  'afr.field.date': '日期',
  'afr.field.masterRefNo': '主单参考号',
  'afr.field.containerNo': '集装箱号',
  'afr.field.containerType': '箱型',
  'afr.field.sealNo': '封条号',
  'afr.field.sealNo2': '第二封条号',
  'afr.field.serviceCode': '服务代码',
  'afr.field.shipperOwned': '货主自备箱',
  'afr.field.shipperRef': '发货人引用代码',
  'afr.field.consigneeRef': '收货人引用代码',
  'afr.field.notifyRef': '通知人引用代码',
  'afr.field.secondNotifyParty': '第二通知方',
  'afr.field.lastHblIndicator': '最后一票分单',
  'afr.field.receiptPlace': '收货地',
  'afr.field.deliveryPlace': '交货地',
  'afr.field.quantity': '包装数量',
  'afr.field.packageUnit': '包装单位',
  'afr.field.unitName': '包装单位名称',
  'afr.field.unitClassOwner': '单位分类所有者',
  'afr.field.grossWeight': '毛重',
  'afr.field.weightUnit': '重量单位',
  'afr.field.cbm': '体积',
  'afr.field.houseRefNo': '分单参考号',
  'afr.field.remark': '备注',
  'afr.field.containerRef': '集装箱引用号',
  'afr.field.originCountry': '原产国',
  'afr.field.marking': '唛头',
  'afr.field.description': '货物描述',
  'afr.field.hsNumber': 'HS 编码',
  'afr.field.unNo': 'UNDG 编号',
  'afr.field.imoClass': 'IMO 类别',
  'afr.field.packingGroup': '包装等级',
  'afr.field.flashPoint': '闪点',
  'afr.field.flashpointUom': '闪点单位',
  'afr.field.hazardousComments': '危险品说明',
  'afr.field.emergencyName': '紧急联系人',
  'afr.field.emergencyPhone': '紧急电话',
  'afr.field.partyCode': '关系方代码',
  'afr.field.partyType': '关系方类型',
  'afr.field.partyName': '关系方名称',
  'afr.field.partyGroup': '组代码',
  'afr.field.partyIdType': '证件类型',
  'afr.field.partyId': '税号',
  'afr.field.addressLines': '地址行',
  'afr.field.city': '城市',
  'afr.field.subdivision': '省/州',
  'afr.field.postalCode': '邮编',
  'afr.field.country': '国家/地区',
  'afr.field.contactName': '联系人',
  'afr.field.email': '邮箱',
  'afr.field.phone': '电话',
  'afr.field.phoneArea': '电话区号',
  'afr.field.fax': '传真',
  'afr.field.faxArea': '传真区号',
  'afr.status.new': '新建',
  'afr.status.submitted': '已提交',
  'afr.status.received': '网关已接收',
  'afr.status.accepted': '海关已受理',
  'afr.status.masterRegistered': '主单已登记',
  'afr.status.hold': '海关扣留',
  'afr.status.holdReleased': '扣留已解除',
  'afr.status.rejected': '被拒绝',
  'afr.status.cancelled': '已作废',
  'afr.status.unknown': '未知状态',
  'afr.action.add': '新增',
  'afr.action.edit': '编辑',
  'afr.action.sync': '主动查询状态',
  'afr.action.previewXml': '预览 XML',
  'afr.action.copy': '复制',
  'afr.action.void': '作废',
  'afr.action.addCargo': '新增货物',
  'afr.action.editCargo': '编辑货物',
  'afr.save.success': 'AFR 草稿已保存。',
  'afr.submit.success': 'AFR 已提交。',
  'afr.sync.success': 'AFR 状态已主动查询并同步。',
  'afr.sync.partial': 'AFR 主动查询已完成，但部分海关回执查询失败。',
  'afr.void.success': 'AFR 已作废。',
  'afr.void.confirm': '确认作废这票 AFR？已提交的申报会先向 E-Freight 发送删除报文。',
  'afr.validation.masterBillRequired': '主提单号不能为空。',
  'afr.validation.filingType': '申报类型只能为进口或转运。',
  'afr.validation.houseRequired': '至少需要一票分单。',
  'afr.validation.houseNoRequired': '分提单号不能为空。',
  'afr.validation.hsNumber': 'HS 编码必须为 6 至 10 位数字。',
  'afr.validation.partiesRequired': '至少需要发货人和收货人两个关系方。',
  'afr.validation.partyNameRequired': '关系方名称不能为空。',
  'afr.validation.summary': '提交前请修正 {count} 个 AFR 申报问题。',
  'afr.changelog.provider': '日本海关 / E-Freight',
  'afr.changelog.risk': '风险评估',
  'afr.list.create': '新建 AFR',
  'afr.list.houseCount': '分单数',
  'afr.list.vesselVoyage': '船名 / 航次',
  'afr.list.route': '装货港 / 卸货港',
  'afr.list.lastDisposition': '最新回执',
  'afr.list.owner': '负责人',
};
